import React, { useState } from "react";
import { Flower2, Plus } from "lucide-react";
import { useTrolley } from "../../context/TrolleyContext";

const CARD_TINTS = ["#FFC2D1", "#FFE9A8", "#C8EFF9", "#D9F2E3", "#E1CFF2", "#FFDDC9"];

export const ProductCard = ({ product, index = 0, onOpen }) => {
  const { add } = useTrolley();
  const [burst, setBurst] = useState(false);
  const tint = CARD_TINTS[index % CARD_TINTS.length];
  const multi = (product.variants || []).length > 1;
  const soldOut = !(product.variants || []).some((v) => v.available);
  const prices = (product.variants || []).map((v) => v.price);
  const from = prices.length && Math.min(...prices) !== Math.max(...prices);

  const quickAdd = () => {
    const v = (product.variants || []).find((x) => x.available);
    if (!v) return;
    add(product, v, 1);
    setBurst(true);
    setTimeout(() => setBurst(false), 700);
  };

  return (
    <div
      data-testid={`supply-card-${product.handle || product.id}`}
      className="relative group bg-warmwhite border-[3px] border-plum-deep rounded-[1.75rem] overflow-hidden transition-transform duration-300 hover:-translate-y-2 hover:rotate-[-0.7deg] hover:shadow-[0_24px_40px_-20px_rgba(74,27,77,0.45)]"
    >
      <button onClick={() => onOpen(product)} className="block w-full text-left" data-testid={`supply-open-${product.handle || product.id}`}>
        <div className="relative aspect-square overflow-hidden" style={{ background: tint }}>
          {product.images?.[0] && (
            <img src={product.images[0]} alt={product.title} loading="lazy"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.06] group-hover:rotate-[1deg]" />
          )}
          {soldOut && (
            <span className="absolute top-3 left-3 bg-plum-deep text-cream text-[10px] uppercase font-bold tracking-[0.14em] px-3 py-1.5 rounded-full">SOLD OUT</span>
          )}
          {product.on_sale && !soldOut && (
            <span className="absolute top-3 left-3 bg-orange text-cream text-[10px] uppercase font-bold tracking-[0.14em] px-3 py-1.5 rounded-full">BARGAIN</span>
          )}
          {burst && (
            <span className="absolute inset-0 flex items-center justify-center pointer-events-none">
              <Flower2 className="w-16 h-16 text-magenta animate-bloom-pop" />
            </span>
          )}
        </div>
        <div className="p-4 pb-2">
          <p className="text-[9px] uppercase tracking-[0.22em] text-plum/70 font-bold">{product.category}</p>
          <h3 className="font-serif-display uppercase text-plum-deep text-[15px] leading-snug mt-1 line-clamp-2">{product.title}</h3>
        </div>
      </button>
      <div className="px-4 pb-4 flex items-center justify-between gap-2">
        <p className="font-bold text-plum-deep text-base">
          {from && <span className="text-[10px] uppercase tracking-[0.1em] text-plum-deep/60 mr-1">FROM</span>}
          ${product.price_from?.toFixed(2)}
        </p>
        <button
          onClick={multi ? () => onOpen(product) : quickAdd}
          disabled={soldOut}
          data-testid={`supply-add-${product.handle || product.id}`}
          className="inline-flex items-center gap-1.5 rounded-full bg-magenta text-cream pl-3 pr-4 py-2 text-[11px] uppercase tracking-[0.1em] font-bold transition-all hover:bg-plum active:scale-90 disabled:opacity-40"
        >
          <Plus className="w-3.5 h-3.5" /> {multi ? "OPTIONS" : "ADD"}
        </button>
      </div>
    </div>
  );
};
